
import {Component, Vue} from "vue-property-decorator";
import SiteHeader from "@/components/UI/renewal/SiteHeader.vue";
import TemplateFooter from "@/components/UI/templates/TemplateFooter.vue";
import HomeContent from "@/components/home/HomeContent.vue";

@Component({
  components: {
    SiteHeader,
    TemplateFooter,
    HomeContent,
  },
})
export default class Home extends Vue {
}
